<template>
    <div class="add-work-email">
        <div class="content">
            <div class="data-title">
                <div class="title-name">编辑公告内容</div>
            </div>
            <div class="text">基本信息</div>
            <div class="forms">
                <el-form :inline="true" :model="form" ref="form" :rules="rules" class="form" size="small"
                    label-width="96px" autocomplete="off">
                    <el-form-item label="标题:" prop="title">
                        <el-input v-model="form.title" placeholder="请输入" maxlength="50" clearable :disabled="isReadonly"
                            show-word-limit></el-input>
                    </el-form-item>

                    <el-form-item label="选择分类:" prop="category" class="add-category">
                        <div class="category-container">
                            <el-select v-model="form.category" placeholder="请选择" style="width: 100%;margin-right: 16px;"
                                :disabled="isReadonly">
                                <el-option v-for="item in categoryList" :key="item.id" :label="item.categoryName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                            <div class="add-category-btn" style="cursor: pointer;" @click="showAddCategoryDialog"
                                v-if="btnPermission.createCategory">
                                <img src="@/assets/img/announcement/add.png"
                                    style="width: 10px; height: 10px; margin-right: 4px;">
                                <span>新建分类</span>
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item label="作者:" class="t-label">
                        <el-input v-model="form.author" placeholder="请输入" clearable maxlength="256" rows="3"
                            show-word-limit :disabled="isReadonly"></el-input>
                    </el-form-item>
                    <el-form-item label="接收人员:" prop="receivers" class="label-star">
                        <div class="category-container">
                            <el-select v-model="form.receivers" placeholder="请选择接收人员" @click.native="openUserPicker"
                                class="select-u" collapse-tags size="medium" multiple popper-class="hidden"
                                style="margin-right: 16px;width: 100%;" :disabled="isReadonly">
                                <el-option v-for="(user, index) in form.receivers" :key="index" :label="user.name"
                                    :value="user">
                                </el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                    <el-form-item label="正文:" prop="content" class="label-star" style="display: flex;">
                        <template #label>
                            <div style="width: 88px;">正文:</div>
                        </template>
                        <div style="border: 1px solid #ccc;width: 104vh;position: relative;">
                            <template v-if="editorReady && !isReadonly">
                                <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor"
                                    :defaultConfig="toolbarConfig" :mode="mode" />
                            </template>
                            <Editor style="height: 500px; overflow-y: hidden;" v-model="html"
                                :defaultConfig="editorConfig" :mode="mode" @onChange="onEditorChange"
                                @onCreated="onCreated" />
                            <!-- 添加字数统计显示 -->
                            <div class="word-count">{{ wordCount }}/10000</div>
                        </div>
                    </el-form-item>
                    <el-form-item label="附件:" prop="attachmentList" class="label-star" style="display: flex;">
                        <div style="width: 100%;">
                            <attachment-upload v-model="form.attachmentList" :disabled="isReadonly"></attachment-upload>
                        </div>
                    </el-form-item>

                    <div class="line"></div>
                    <p>更多信息</p>
                    <div class="more-info">
                        <el-row :gutter="24">
                            <el-col :span="6">
                                <el-form-item label="创建时间：">
                                    <div class="con">{{ formatDateTime(form.createdTime) }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="发起人：">
                                    <div class="con">{{ form.createdByName || '-' }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="审批状态：">
                                    <!-- {{ dictionaries.notice_approval_status[form.approvalStatus == dictId]  }} -->

                                    <div class="con">{{ getDictName(dictionaries.notice_approval_status,
                                        form.approvalStatus) }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="公告状态：">
                                    <div class="con">{{ getDictName(dictionaries.notice_status, form.noticeStatus) }}
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="24">
                            <el-col :span="6">
                                <el-form-item label="更新时间：">
                                    <div class="con">{{ formatDateTime(form.updatedTime) }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="最近更新人：">
                                    <div class="con">{{ form.updatedByName || '-' }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="发布时间：">
                                    <div class="con">{{ formatDateTime(form.publishTime) }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="发送人数：">
                                    <div class="con">{{ form.sendCount || '-' }}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="24">
                            <el-col :span="6">
                                <el-form-item label="已读人数：">
                                    <div class="con">{{ form.readCount || '-' }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="确认人数：">
                                    <div class="con">{{ form.confirmCount || '-' }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="未读人数：">
                                    <div class="con">{{ form.unreadCount || '-' }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="审批详情：">
                                    <div class="con"><el-button type="primary" class="btn-look" plain size="mini"
                                            @click="showApprovalDetail" :loading="approvalBtnLoading"
                                            :disabled="!form.processInstanceId">查看</el-button>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>
            </div>
            <div class="footer" :class="[isCollapsed ? 'footer-collapsed' : '']">
                <el-button type="info" plain @click="back">返回</el-button>
                <el-button type="primary" plain @click="reset" v-if="btnPermission.reset">重置</el-button>
                <el-button type="primary" plain @click="preview">预览</el-button>
                <el-button type="primary" @click="save" :loading="btnSave" v-if="btnPermission.save && String(form.noticeStatus) === '3'">保存草稿</el-button>
                <el-button type="primary" plain @click="exportReadList" v-if="btnPermission.exportRead">导出名单</el-button>
                <el-button type="danger" @click="cancel" v-if="canCancel === true">撤销</el-button>
                <el-button type="danger" @click="revoke" v-if="btnPermission.down">撤回公告</el-button>
                <el-button type="primary" @click="submit" :loading="btnSubmit"
                    v-if="btnPermission.submit">提交</el-button>
                <el-button type="primary" @click="showApprovalDialog" :loading="btnApprovalLoading"
                    v-if="taskId !== null && isReadonly">审批</el-button>
            </div>

            <!-- 新建分类弹窗 -->
            <el-dialog class="add-category-dialog" :visible.sync="addCategoryDialogVisible" width="520px"
                :modal="false">
                <el-form :model="newCategoryForm" ref="newCategoryForm">
                    <el-form-item label="分类名" prop="name">
                        <template #label>
                            <div class="dialog-title" style="text-align: left;">分类名 <br />
                                <span>新建分类默认排在最后，可在分类列表中调整显示排序</span>
                            </div>
                        </template>
                        <el-input v-model="newCategoryForm.name" placeholder="请输入名称(限10个字符)" maxlength="10"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addCategoryDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="addCategory">确定</el-button>
                </span>
            </el-dialog>

            <!-- 审批对话框 -->
            <el-dialog class="approval-dialog" :append-to-body="true" :visible.sync="approvalDialogVisible"
                width="500px" title="审批">
                <div class="apply-title">请确认审批结果</div>
                <el-form :model="approvalForm" :rules="approvalRules" ref="approvalForm" label-width="80px">
                    <el-form-item label="审批结果" prop="type">
                        <el-radio-group v-model="approvalForm.type">
                            <el-radio label="pass">通过</el-radio>
                            <el-radio label="reject">驳回</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="备注" prop="comment">
                        <el-input type="textarea" v-model="approvalForm.comment" :rows='4' maxlength="64"
                            show-word-limit></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="approvalDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitApproval">确定</el-button>
                </span>
            </el-dialog>

            <!-- 公告预览弹窗 -->
            <div>
                <el-dialog class="preview-dialog" :append-to-body="true" :visible.sync="previewDialogVisible"
                    width="800px" title="公告预览" :modal="true">
                    <div class="preview-content">
                        <div class="preview-title">
                            <span>{{ previewData.title || '无标题' }}</span>
                        </div>

                        <div class="preview-meta">
                            <div class="meta-item" v-if="previewData.categoryName || previewData.author">
                                <span class="meta-value">{{ (previewData.author || '')
                                }}</span>
                                <span style="padding: 0 10px;">|</span>
                                <span style="color: #409EFF;">
                                    {{ '#' + (previewData.categoryName || '') + '#' }}
                                </span>
                            </div>
                            <div class="meta-item">
                                <span>{{ currentTime }}</span>
                            </div>
                        </div>

                        <div class="preview-body">
                            <div class="preview-html" v-html="previewData.content"></div>
                        </div>

                        <div class="preview-attachments"
                            v-if="previewData.attachmentList && previewData.attachmentList.length">
                            <h3>附件</h3>
                            <approval-attachment-list :files="previewData.attachmentList"/>
                        </div>

                        <div class="preview-read">
                            <span style="margin-right: 10px;">{{ form.readCount || 0 }}人已读</span>
                            <span>{{ form.unreadCount || 0 }}人未读</span>
                        </div>
                    </div>

                    <span slot="footer" class="dialog-footer">
                        <el-button @click="previewDialogVisible = false">关闭</el-button>
                    </span>
                </el-dialog>
            </div>

        </div>
        <org-picker title="接收人员" :multiple="true" ref="orgPicker" @ok="selectedUser" />
        <!-- 审批详情弹窗 -->
        <pop-process ref="popProcess" />
    </div>
</template>
<script>
import ApprovalAttachmentList from '@/components/ApprovalAttachmentList.vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import OrgPicker from "@/components/OrgPicker";
import AttachmentUpload from "@/pages/announcement/components/AttachmentUpload.vue";
import PopProcess from "@/pages/assetManagement/common/popProcess";
import { isReadonly } from "vue";

export default {
    name: 'annoucementAdd',
    components: { ApprovalAttachmentList, Editor, Toolbar, OrgPicker, AttachmentUpload, PopProcess },
    computed: {
        isCollapsed() {
            return this.$store.state.isCollapsed
        },
        // 添加只读模式计算属性
        isReadonly() {
            return this.form.approvalStatus == 1; // 审批状态为1时只读 1-审批中 2-审批通过 3-撤销 4-驳回 5-待审核
        },
        // 添加审批权限计算属性
        canApprove() {
            // 检查用户信息是否存在
            if (!this.$store.state.user) {
                return false;
            }
            // 这里根据实际业务逻辑判断用户是否有审批权限
            // 示例：检查用户角色和当前审批状态
            const userRoles = this.$store.state.user.roles || [];
            return userRoles.includes('approver') &&
                (this.form.approvalStatus == 1 || this.form.approvalStatus == 2);
        }
    },
    watch: {
        '$route': {
            handler(to, from) {
                // 检查 from 是否存在，避免 undefined 错误
                if (!from) {
                    // 如果是初次加载，直接初始化页面
                    this.initPage();
                    return;
                }

                // 只有当路由路径变化，或者ID参数变化时重新初始化
                if (to.path === '/announcement/detail' &&
                    (to.path !== from.path || to.query.id !== from.query.id)) {
                    this.initPage();
                }
            },
            immediate: true
        }
    },
    data() {
        //自定义校验图片函数
        const customCheckImageFn = (src, alt, url) => {
            if (!src) {
                return;
            }
            if (src.indexOf('http') !== 0 && src.indexOf('data:image') !== 0) {
                return '图片网址必须以 http/https 开头或为有效的base64数据';
            }
            return true;
        };

        // 转换图片链接
        const customParseImageSrc = (src) => {
            if (src.indexOf('http') !== 0 && src.indexOf('data:image') !== 0) {
                return 'http://${src}';
            }
            return src;
        };
        return {
            announcementId: null, // 公告ID（编辑时使用）
            editor: null,
            html: '',
            toolbarConfig: {
                //配置工具栏，包含图片上传按钮
                excludeKeys: [
                ]
            },
            editorConfig: {
                placeholder: '请输入内容...',
                //配置菜单栏，添加上传图片功能
                MENU_CONF: {
                    uploadImage: {
                        customUpload: this.uploadImage, //自定义上传
                        maxFileSize: 10 * 1024 * 1024, // 10M
                        allowedFileTypes: ['image/*'],
                        base64Upload: true, // 基础64上传，用于粘贴图片
                        onInsertedImage: this.onInsertedImage, // 图片插入成功回调
                        onUpdatedImage: this.onUpdatedImage, // 图片更新成功回调
                        checkImage: customCheckImageFn, // 自定义图片校验函数
                        parseImageSrc: customParseImageSrc // 自定义图片链接转换函数

                    },
                    //插入图片配置
                    insertImage: {
                        onInsertedImage: this.onInsertedImage,
                        checkImage: customCheckImageFn,
                        parseImageSrc: customParseImageSrc
                    },
                    //编辑图片配置
                    editImage: {
                        onUpdatedImage: this.onUpdatedImage,
                        checkImage: customCheckImageFn,
                        parseImageSrc: customParseImageSrc
                    }
                }
            },
            mode: 'default',
            wordCount: 0, //添加字数统计变量
            form: {
                title: '',
                category: '',
                author: '',
                receivers: [],
                attachmentList: [],
                // 更多信息字段
                createdTime: '',
                createdByName: '',
                approvalStatus: '',  // 公告审批状态 1-审批中 2-审批通过 3-撤销 4-驳回 5-待审核
                noticeStatus: '', //公告状态  1-已上架 2-已下架 3-草稿
                updatedTime: '',
                updatedByName: '',
                publishTime: '',
                sendCount: 0,
                readCount: 0,
                confirmCount: 0,
                unreadCount: 0,
                processInstanceId: null // 审批流程实例ID
            },
            canCancel: false, // 是否可以撤销
            categoryList: [],
            addCategoryDialogVisible: false,
            previewDialogVisible: false, // 控制预览对话框显示
            previewData: {}, // 预览数据
            currentTime: new Date().toLocaleString(), // 当前时间，用于模拟发布时间
            newCategoryForm: {
                name: ''
            },
            btnPermission: {},
            btnSave: false,
            btnSubmit: false,
            currentTime: new Date().toLocaleString(), // 当前时间，用于预览
            approvalBtnLoading: false, // 审批详情按钮加载状态
            //审批相关数据
            approvalDialogVisible: false,
            approvalForm: {
                type: 'pass',
                comment: ''
            },
            approvalRules: {
                type: [
                    { required: true, message: '请选择审批结果', trigger: 'change' }
                ],
                comment: [
                    { required: false, message: '请输入审批备注', trigger: 'blur' }
                ]
            },
            btnApprovalLoading: false, // 审批按钮加载状态
            currentTaskId: '', // 当前任务ID
            taskId: null, // 任务ID
            editorReady: false, // 编辑器是否准备好
            dictionaries: { // 字典数据
                notice_status: [], // 公告状态  1-已上架 2-已下架 3-草稿
                notice_approval_status: [], // 公告审批状态 1-审批中 2-审批通过 3-撤销 4-驳回 5-待审核
                notice_read_status: [], // 通知阅读状态
            },
            rules: {
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' }
                ],
                category: [
                    { required: false, message: '请选择分类', trigger: 'change' }
                ],
                receivers: [
                    { required: false, message: '请输入接收人员', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        // 初始化页面数据
        this.initPage();
        // 获取字典值
        for (const type in this.dictionaries) {
            this.getDictionaries(type)
        }
    },
    mounted() {
        // 监听路由变化
        this.$watch(
            () => this.$route,
            (to, from) => {
                // 只有当路由确实发生变化且是当前组件时才重新初始化
                if (to.path === '/announcement/detail' && to.path !== from.path) {
                    // console.log('路由发生变化，重新初始化页面数据', to, from);
                    this.initPage();
                }
            }
        );

    },
    beforeDestroy() {
        this.editorReady = false;
        if (this.editor) {
            try {
                // 移除所有事件监听器
                this.editor.off('change');
                this.editor.off('update');
                // 禁用并销毁编辑器
                this.editor.disable();
                this.editor.destroy();
            } catch (error) {
                console.error('销毁编辑器时出错:', error);
            } finally {
                this.editor = null;
            }
        }
        // 移除全局事件监听
        if (this.unhandledRejectionHandler) {
            window.removeEventListener('unhandledrejection', this.unhandledRejectionHandler);
        }
    },

    methods: {
        // 初始化页面
        initPage() {
            // 重置表单数据
            this.resetForm();
            // 按钮权限
            this.buttonPermission();
            // 从路由参数获取isEdit和id
            this.announcementId = this.$route.query.id || null;


            // 获取分类列表
            this.fetchCategories();

            this.fetchAnnouncementDetail();

            // this.getTaskId()


        },

        // 重置表单数据
        resetForm() {
            this.form = {
                title: '',
                category: '',
                author: '',
                receivers: [],
                attachmentList: [],
                // 更多信息字段
                createdTime: '',
                createdByName: '',
                approvalStatus: '',
                noticeStatus: '',
                updatedTime: '',
                updatedByName: '',
                publishTime: '',
                sendCount: 0,
                readCount: 0,
                confirmCount: 0,
                unreadCount: 0
            };
            this.html = '';
            this.addCategoryDialogVisible = false;
            this.newCategoryForm.name = '';
            this.btnSave = false;
            this.btnSubmit = false;

            // 重置表单验证
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },

        // 时间格式化方法
        formatDateTime(dateTime) {
            if (!dateTime || dateTime === '-') return '-';

            try {
                // 解析ISO格式时间
                const date = new Date(dateTime);

                // 检查日期是否有效
                if (isNaN(date.getTime())) return dateTime;

                // 格式化为 YYYY-MM-DD HH:mm:ss
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');

                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } catch (error) {
                console.error('日期格式转换错误:', error);
                return dateTime;
            }
        },

        // 获取公告详情
        fetchAnnouncementDetail() {
            this.$api.announcementEditDetail({ id: this.announcementId }).then(res => {
                if (res.code == 0) {
                    const detail = res.data;

                    // 回显数据到表单
                    this.form.title = detail.title || '';
                    this.form.category = detail.categoryId || '';
                    this.form.author = detail.author || '';
                    this.html = this.processContent(detail.content || '');
                    //如果编辑器已经创建，则手动设置内容
                    this.$nextTick(() => {
                        if (this.isEditorReady()) {
                            this.safeSetHtml(this.html);
                        }
                    })

                    // 回显更多信息字段
                    this.form.createdTime = detail.createdTime || '-';
                    this.form.createdByName = detail.createdByName || '-';
                    this.form.approvalStatus = detail.approvalStatus || '-';
                    this.form.noticeStatus = detail.noticeStatus || '-';
                    this.form.updatedTime = detail.updatedTime || '-';
                    this.form.updatedByName = detail.updatedByName || '-';
                    this.form.publishTime = detail.publishTime || '-';
                    this.form.sendCount = detail.sendCount || '-';
                    this.form.readCount = detail.readCount || 0;
                    this.form.confirmCount = detail.confirmCount || '-';
                    this.form.unreadCount = detail.unreadCount || '-';

                    //获取审批详情实例id
                    this.form.processInstanceId = detail.processInstanceId || null;

                    // 回显接收人员
                    if (detail.receiveList && Array.isArray(detail.receiveList)) {
                        this.form.receivers = detail.receiveList;
                    }

                    // 回显附件
                    if (detail.attachmentList && Array.isArray(detail.attachmentList)) {
                        this.form.attachmentList = detail.attachmentList.map(att => ({
                            id: att.id,
                            name: att.name,
                            url: att.url,
                            size: att.size,
                            type: att.type,
                            status: 'success'
                        }));
                    }

                    if (detail.approvalStatus != 5) {
                        this.getProcessFormDetail();
                    }

                    if (detail.approvalStatus == 1) {
                        this.getTaskId(this.form.processInstanceId)
                    }


                } else {
                    this.$message.error('获取公告详情失败');
                }
            }).catch(err => {
                console.error('获取公告详情出错:', err);
                this.$message.error('获取公告详情出错');
            });
        },

        fetchCategories() {
            return this.$api.announcementCList().then(res => {
                if (res.code == 0) {
                    this.categoryList = res.data.map(item => {
                        return {
                            id: item.id,
                            categoryName: item.categoryName,
                            editing: false,
                            tempName: "",
                        }
                    });
                    return this.categoryList; // 返回分类列表
                }
            }).catch(error => {
                console.error('获取分类列表失败:', error);
                this.$message.error('获取分类列表失败');
                return [];
            });
        },

        // 安全设置编辑器内容的方法
        safeSetHtml(html) {
            if (!this.editor || this.editor.isDestroyed) {
                console.warn('编辑器未准备好，延迟设置内容');
                setTimeout(() => this.safeSetHtml(html), 100);
                return;
            }
            try {
                this.editor.setHtml(html);
            } catch (error) {
                console.error('设置编辑器内容失败:', error);
            }
        },

        // 检查编辑器状态
        isEditorReady() {
            return this.editor &&
                !this.editor.isDestroyed &&
                this.editor.getEditableContainer();
        },

        // 处理内容格式
        processContent(html) {
            // 这里可以添加对特定格式的处理逻辑
            return html;
        },

        // 添加编辑器变化监听
        onEditorChange(editor) {
            // 更新字数统计
            this.updatewordCount(editor);
        },

        //字数统计方法
        updatewordCount(editor) {
            if (!editor) return;

            //获取纯文本内容并计算字数
            const text = editor.getText();

            //去除首尾空格并计算字数
            const count = text.trim() ? text.trim().length : 0;
            this.wordCount = count;

            // 如果超过限制，撤销最后一次操作
            if (count > 10000) {
                this.$message.warning('公告内容不能超过10000字，请修改后重新提交！');
                editor.undo();
                // 重新计算字数
                const newText = editor.getText().trim();
                this.wordCount = newText ? newText.length : 0;
            }
        },

        // 修改后的添加分类方法
        addCategory() {
            this.$refs.newCategoryForm.validate((valid) => {
                if (valid) {
                    // 调用API添加分类
                    this.$api.announcementCAdd({ categoryName: this.newCategoryForm.name }).then(res => {
                        if (res.code === 0) {
                            this.$message.success('分类添加成功');
                            this.addCategoryDialogVisible = false;

                            // 刷新分类列表
                            this.fetchCategories().then(categoryList => {
                                // 查找新添加的分类（通过名称匹配）
                                const newCategory = categoryList.find(
                                    cat => cat.categoryName === this.newCategoryForm.name
                                );

                                if (newCategory) {
                                    // 设置新添加的分类为选中状态
                                    this.form.category = newCategory.id;
                                } else {
                                    console.warn('未能找到新添加的分类');
                                }
                            });
                        } else {
                            this.$message.error(res.msg || '添加分类失败');
                        }
                    }).catch(err => {
                        console.error('添加分类失败:', err);
                        // 这里不再显示错误消息，避免重复提示
                    });
                }
            });
        },

        // 显示审批详情
        showApprovalDetail() {
            if (!this.form.processInstanceId) {
                this.$message.warning('该公告没有审批流程信息');
                return;
            }

            this.approvalBtnLoading = true;

            // 调用审批详情组件
            this.$refs.popProcess.show(this.form.processInstanceId);

            // 模拟加载，实际使用时可以根据需要调整
            setTimeout(() => {
                this.approvalBtnLoading = false;
            }, 500);
        },

        formatFileSize(size) {
            if (size < 1024) {
                return size + 'B';
            } else if (size < 1024 * 1024) {
                return (size / 1024).toFixed(2) + 'KB';
            } else if (size < 1024 * 1024 * 1024) {
                return (size / (1024 * 1024)).toFixed(2) + 'MB';
            } else {
                return (size / (1024 * 1024 * 1024)).toFixed(2) + 'GB';
            }
        },

        // 预览方法
        preview() {
            // 验证表单必填项
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // 收集预览数据
                    const category = this.categoryList.find(item => item.id === this.form.category);

                    this.previewData = {
                        title: this.form.title,
                        categoryName: category ? category.categoryName : '',
                        author: this.form.author,
                        receivers: this.form.receivers,
                        content: this.html,
                        attachmentList: this.form.attachmentList.filter(file => file.status === 'success').map(file => ({
                            name: file.name,
                            url: file.url,
                            size: file.size,
                            type: file.type
                        }))
                    };

                    // 显示预览对话框
                    this.previewDialogVisible = true;
                } else {
                    this.$message.warning('请填写必填项后再预览');
                    return false;
                }
            });
        },

        // 显示新建分类弹窗
        showAddCategoryDialog() {
            this.newCategoryForm.name = '';
            this.addCategoryDialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.newCategoryForm) {
                    this.$refs.newCategoryForm.clearValidate();
                }
            });
        },

        //导出名单
        exportReadList() {
            this.$api.announcementReadExport({ id: this.$route.query.id }).then(res => {
                if (res.code == 0) {
                    const link = document.createElement("a");
                    link.href = res.data;
                    link.download = "公告阅读名单.xls";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.$message.success('导出成功')
                } else {
                    this.$message.error(res.message || '导出失败')
                }
            }).catch(err => {
                this.$message.error('导出失败')
            })
        },

        // 显示审批对话框
        showApprovalDialog() {
            this.approvalForm = {
                type: 'pass',
                comment: ''
            };
            this.approvalDialogVisible = true;

            // 重置表单验证
            this.$nextTick(() => {
                if (this.$refs.approvalForm) {
                    this.$refs.approvalForm.clearValidate();
                }
            });
        },

        // 通过id获取流程表单详情
        getProcessFormDetail() {
            this.$api.workflowDetail({ processInstanceId: this.form.processInstanceId }).then(res => {
                if (res.code === 0) {
                    this.currentTaskId = res.data.currentTaskId;
                    this.canCancel = res.data.canCancel;
                }
            })
        },

        //按钮权限
        buttonPermission() {
            this.$api.announcementButtonPermission([this.$route.query.id]).then(res => {
                if (res.code === 0) {
                    // 从 noticePermissionMap 中按当前公告ID取子对象
                    const map = res.data && res.data.noticePermissionMap ? res.data.noticePermissionMap : {}
                    const id = this.$route.query.id
                    // 兼容数字/字符串键，或只有一个键值的场景
                    const byId = (map && (map[id] || map[String(id)]))
                    const firstValue = map && typeof map === 'object' ? Object.values(map)[0] : {}
                    this.btnPermission = byId || firstValue || {}
                }
            })
        },

        //获取任务id
        getTaskId() {
            this.$api.announcementTaskId(this.form.processInstanceId).then(res => {
                if (res.code === 0) {
                    this.taskId = res.data || null;
                }
            })
        },

        // 提交审批
        submitApproval() {
            this.$refs.approvalForm.validate((valid) => {
                if (valid) {
                    this.btnApprovalLoading = true;
                    this.approvalDialogVisible = false;

                    // 根据审批结果调用不同API
                    const apiName = this.approvalForm.type === 'pass'
                        ? 'announcementApprove'
                        : 'announcementReject';

                    const postData = {
                        taskId: this.currentTaskId,
                        comments: this.approvalForm.comment
                    };

                    this.$api.workflowComplete(postData).then(res => {
                        if (res.code === 0) {
                            this.$message.success('审批操作成功');


                            // 刷新页面数据
                            this.fetchAnnouncementDetail();
                            this.buttonPermission()
                            location.reload();
                        } else {
                            this.$message.error(res.msg || '审批操作失败');
                        }
                    }).catch(err => {
                        console.error('审批操作出错:', err);
                        this.$message.error('审批操作出错');
                    }).finally(() => {
                        this.btnApprovalLoading = false;
                    });
                }
            });
        },

        // 检查是否有审批权限
        // hasApprovalPermission() {
        //     // 这里根据实际业务逻辑实现权限检查
        //     // 示例：检查用户角色或特定权限
        //     const userRoles = this.$store.state.user.roles || [];
        //     return userRoles.includes('approver') || userRoles.includes('admin');
        // },

        // 检查公告是否可审批
        // canApproval() {
        //     // 根据业务逻辑判断公告当前状态是否允许审批
        //     // 示例：只有待审批状态的公告可以审批
        //     return this.form.approvalStatus === '待审批' ||
        //         this.form.approvalStatus === '审批中';
        // },

        //撤销
        cancel() {
            const params = {
                processInstanceId: this.form.processInstanceId,
                taskId: this.currentTaskId,
            }
            this.$confirm('确定撤销该公告吗？').then(() => {
                this.$api.workflowRevoke(params).then(res => {
                    if (res.code === 0) {
                        this.$message.success('撤销成功')
                        // 刷新页面数据
                        this.fetchAnnouncementDetail();
                        // 刷新按钮权限
                        this.buttonPermission();
                    } else {
                        this.$message.error(res.msg || '撤销失败')
                    }
                })
            })
        },

        //撤回公告
        revoke() {
            this.$confirm('确定撤回该公告吗？').then(() => {
                this.$api.announcementRevokeNotice({ id: this.$route.query.id }).then(res => {
                    if (res.code === 0) {
                        this.$message.success('撤回成功')
                        this.back()
                    } else {
                        this.$message.error(res.msg || '撤回失败')

                    }
                })
            })
        },

        getDictName(dictType, value) {
            if (!value && value !== 0) return '-';

            const dictList = dictType;

            const foundItem = dictList.find(item =>
                item.dictId == value
            );

            return foundItem ? foundItem.dictName : '-';
        },

        // 自定义图片上传方法
        uploadImage(file, insertFn) {
            // 如果是粘贴的图片，可能是base64格式
            if (typeof file === 'string' && file.startsWith('data:image')) {
                // 处理base64图片
                this.uploadBase64Image(file, insertFn);
                return;
            }

            // 普通文件上传
            const formData = new FormData();
            formData.append('file', file);

            this.$api.uploadFile(formData).then(res => {
                if (res.code === 0) {
                    // 上传成功，插入图片
                    insertFn(res.data.url, '', '');
                    this.$message.success('图片上传成功');
                } else {
                    this.$message.error(res.msg || '图片上传失败');
                }
            }).catch(error => {
                console.error('图片上传失败:', error);
                this.$message.error('图片上传失败');
            });
        },

        // 处理base64图片上传
        uploadBase64Image(base64, insertFn) {
            // 将base64转换为blob
            const blob = this.dataURLtoBlob(base64);
            const formData = new FormData();
            formData.append('file', blob, 'pasted-image.png');

            this.$api.uploadFile(formData).then(res => {
                if (res.code === 0) {
                    // 上传成功，插入图片
                    insertFn(res.data.url, '', '');
                    this.$message.success('图片上传成功');
                } else {
                    this.$message.error(res.msg || '图片上传失败');
                    // 上传失败，直接插入base64（不推荐，但作为备选方案）
                    insertFn(base64, '', '');
                }
            }).catch(error => {
                console.error('图片上传失败:', error);
                this.$message.error('图片上传失败');
                // 上传失败，直接插入base64（不推荐，但作为备选方案）
                insertFn(base64, '', '');
            });
        },

        // 将base64转换为Blob对象
        dataURLtoBlob(dataurl) {
            const arr = dataurl.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        },

        // 插入图片后的回调
        onInsertedImage(imageNode) {
            if (imageNode == null) return;
            const { src, alt, url, href } = imageNode;
        },

        // 更新图片后的回调
        onUpdatedImage(imageNode) {
            if (imageNode == null) return;
            const { src, alt, url } = imageNode;
        },

        // 修改onCreated方法
        onCreated(editor) {
            try {
                this.editor = Object.seal(editor);

                // 初始化字数统计
                this.updatewordCount(editor);

                // 确保编辑器完全初始化后再设置监听
                setTimeout(() => {
                    try {
                        if (editor && editor.config) {
                            editor.config.onchange = (editor) => {
                                this.updatewordCount(editor);
                            };
                        } else if (editor && editor.on) {
                            editor.on('change', () => {
                                this.updatewordCount(editor);
                            });
                        }
                    } catch (error) {
                        console.error('设置编辑器监听失败:', error);
                    }
                }, 100);

                // 设置编辑器只读状态
                if (this.isReadonly && editor && editor.disable) {
                    editor.disable();
                }
            } catch (error) {
                console.error('编辑器初始化失败:', error);
            }
        },

        //获取字典数据
        getDictionaries(type) {
            if (type && this.dictionaries[type].length > 0) {
                return
            }
            const params = { groupId: type }
            this.$api.dictionaries(params).then(res => {
                this.dictionaries[type] = res.data || []
            }).catch((err) => {
                console.log(err)
            })
        },

        //打开人员选择器
        openUserPicker() {
            this.$refs.orgPicker.show(this.form.receivers);
        },

        //人员选择回调
        selectedUser(data) {
            this.form.receivers = data;
        },

        back() {
            this.$router.go(-1)
        },

        reset() {
            this.form = {
                title: '',
                category: '',
                author: '',
                receivers: [],
                attachmentList: [],
                // 更多信息字段
                createdTime: '',
                createdByName: '',
                approvalStatus: '',
                noticeStatus: '',
                updatedTime: '',
                updatedByName: '',
                publishTime: '',
                sendCount: 0,
                readCount: 0,
                confirmCount: 0,
                unreadCount: 0
            };
            this.html = '';
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },

        save() {
            {
                    this.btnSave = true;

                    // 确保使用最新的编辑器内容
                    const currentContent = this.editor ? this.editor.getHtml() : this.html;

                    // 构建保存数据
                    const saveData = {
                        id: this.$route.query.id,
                        title: this.form.title,
                        categoryId: this.form.category,
                        author: this.form.author,
                        receiveList: this.form.receivers,
                        content: currentContent, // 使用当前编辑器内容
                        attachmentList: this.form.attachmentList.filter(file => file.status === 'success').map(file => ({
                            id: file.id,
                            name: file.name,
                            url: file.url,
                            size: file.size,
                            type: file.type
                        }))
                    };
                    console.log('保存数据:', saveData);

                    this.$api.announcementSave(saveData).then(res => {
                        this.btnSave = false;
                        if (res.code === 0) {
                            this.$message({
                                message: '草稿已保存',
                                type: 'success'
                            });
                            // 通知列表页刷新数据
                            this.$bus.$emit('refreshAnnouncementList');
                            this.back();
                        } else {
                            this.$message.error(res.msg || ('保存失败'));
                        }
                    }).catch(err => {
                        this.btnSave = false;
                        this.$message.error('保存失败');
                    });
            }
        },
        submit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.btnSubmit = true;

                    // 确保使用最新的编辑器内容
                    const currentContent = this.editor ? this.editor.getHtml() : this.html;


                    // 构建保存数据
                    const submitData = {
                        id: this.$route.query.id,
                        title: this.form.title,
                        categoryId: this.form.category,
                        author: this.form.author,
                        receiveList: this.form.receivers,
                        content: currentContent, // 使用当前编辑器内容
                        attachmentList: this.form.attachmentList.filter(file => file.status === 'success').map(file => ({
                            name: file.name,
                            url: file.url,
                            size: file.size,
                            type: file.type
                        }))
                    };
                    this.$api.announcementSubmit(submitData).then(res => {
                        this.btnSubmit = false;
                        if (res.code === 0) {
                            this.$message({
                                message: '公告提交成功',
                                type: 'success'
                            });
                            // 通知列表页刷新数据
                            this.$bus.$emit('refreshAnnouncementList');
                            this.back();
                        } else {
                            this.$message.error(res.msg || ('提交失败'));
                        }
                    }).catch(err => {
                        this.btnSubmit = false;
                        this.$message.error('提交失败');
                    });
                }
            });
        },
    }
}
</script>
<style lang="scss" src="@/pages/announcement/common/style/add.scss" scoped />
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
// 预览对话框样式
.preview-dialog {
    .preview-content {
        padding: 0 20px;
        max-height: 70vh;
        overflow-y: auto;

        .preview-title {
            text-align: left;
            margin-bottom: 20px;
            font-weight: bold;
            font-size: 24px;
            color: #1E1E1E;
            padding-bottom: 8px;
        }

        .preview-meta {
            margin-bottom: 20px;
            padding-bottom: 15px;

            .meta-item {
                display: flex;
                margin-bottom: 8px;
                font-weight: 500;
                font-size: 12px;


                .meta-value {
                    font-weight: 500;
                    font-size: 14px;
                    color: #1E1E1E;
                }
            }
        }

        .preview-body {
            margin-bottom: 20px;

            ::v-deep .preview-html {
                line-height: 1.6;

                p {
                    margin-bottom: 1em;
                }

                img {
                    max-width: 100%;
                    height: auto;
                }

                table {
                    width: 100%;
                    border-collapse: collapse;

                    th,
                    td {
                        border: 1px solid #ddd;
                        padding: 8px;
                    }

                    th {
                        background-color: #f5f5f5;
                    }
                }
            }
        }

        .preview-attachments {
            margin-top: 20px;
            padding-top: 15px;
            border-top: 1px solid #eee;

            h3 {
                margin-bottom: 12px;
                color: #333;
                font-size: 16px;
            }

            .attachment-list {
                display: flex;
                flex-wrap: wrap;
                gap: 15px;
                list-style: none;
                padding: 0;
                margin: 0;

                .attachment-item {
                    display: flex;
                    align-items: center;
                    width: 245px;
                    padding: 10px;
                    background-color: #f9f9f9;
                    border-radius: 4px;
                    border: 1px solid #eee;
                    cursor: pointer;
                    transition: background-color 0.2s;

                    &:hover {
                        background-color: #f0f0f0;
                    }

                    .el-icon-document {
                        width: 32px;
                        height: 32px;
                        margin-right: 8px;
                        flex-shrink: 0;
                    }

                    .file-info {
                        display: flex;
                        flex-direction: column;
                        flex: 1;
                        min-width: 0;
                    }

                    .file-name {
                        color: #333;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        line-height: 1.4;
                        margin-bottom: 4px;
                    }

                    .file-size {
                        color: #999;
                        font-size: 12px;
                        flex-shrink: 0;
                    }
                }
            }
        }

        .preview-read {
            margin-top: 0;
            /* 移除自动边距 */
            padding: 15px 0 30px;
            border-top: 1px solid #eee;
            color: #7F7F7F;
            font-size: 14px;

        }
    }

    // 对话框底部按钮
    ::v-deep .el-dialog__footer {
        text-align: center;
    }
}

// 审批对话框样式
.approval-dialog {
    .apply-title {
        font-size: 12px;
        color: #939696;
        text-align: center;
        margin-bottom: 12px;
    }
}

.approval-dialog /deep/ {
    .el-dialog__header {
        padding: 16px 0 0;
        height: 54px;
        box-sizing: border-box;
    }

    .el-dialog__body {
        padding: 16px 36px 0 32px;
    }

    .el-form-item {
        margin-bottom: 26px;
    }

    .el-dialog__footer {
        padding: 6px 0 16px;
    }
}
</style>
